export default {
  PreferredFirstNameFormField__ARIA: "Preferred first name",
  PreferredFirstNameFormField__LABEL: "Preferred first name",
};
